<template>
  <MakerCartGuideLayout
    pageTitle="Maker Approach"
    heroImage="/images/maker-cart-guide/frame-1000006402.png"
    previousUrl="/makercart/guide/1"
    nextUrl="/makercart/guide/3"
  >
    <div class="x-section">
      <div class="x-image-container-flat">
        <img
          src="/images/maker-cart-guide/tinker-to-discover.svg"
          height="150px"
          alt="Tinker to Discover"
        />
      </div>
      <div class="x-section-content">
        <h2 class="x-section-title">Tinker to Discover</h2>
        <div class="x-section-body">
          <p>
            <span class="green-bold">Open-ended exploration</span> allows
            learners to direct their own discovery, promoting curiosity,
            experimentation, and autonomous learning.
          </p>
          <p>
            <span class="green-bold"
              >Learners’ autonomy and learner-driven activities</span
            >
            promote self-directed tinkering, so learners have the freedom and
            control over their learning with their own interest and initiatives.
          </p>
        </div>
      </div>
    </div>

    <div class="x-section">
      <div class="x-image-container-flat">
        <img
          src="/images/maker-cart-guide/make-to-learn.svg"
          height="150px"
          alt="Make to Learn"
        />
      </div>
      <div class="x-section-content">
        <h2 class="x-section-title">Make to Learn</h2>
        <div class="x-section-body">
          <p>
            <span class="green-bold">Defined path and tasks</span> provide
            structure for hands-on learning, encouraging creativity and
            problem-solving within the framework.
          </p>
          <p>
            <span class="green-bold">More scaffolded guidance</span> supports
            learners as they build new skills and explore solutions. Learners
            can have the access to examples and coaches while tackling
            challenges that are just beyond their abilities.
          </p>
        </div>
      </div>
    </div>

    <div class="x-section">
      <div class="x-image-container-flat">
        <img
          src="/images/maker-cart-guide/application-project.svg"
          height="150px"
          alt="Application Project"
        />
      </div>
      <div class="x-section-content">
        <h2 class="x-section-title">Application Project</h2>
        <div class="x-section-body">
          <p>
            <span class="green-bold"
              >Stimulating and challenging for learners</span
            >, stretching their abilities to learn and reflect, and allowing
            them to apply their knowledge to real-world projects.
          </p>
          <p>
            <span class="green-bold"
              >Create an artefact demonstrating their learning</span
            >, providing evidence of learners’ understanding and gives them a
            tangible product to showcase their learning experiences.
          </p>
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";
</script>

<style scoped>
@media (max-width: 768px) {
  :deep(.x-section img) {
    height: 100px;
    width: 100px;
  }
}
</style>
